// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Pq-z","imageAndVideoCount":"Qq-z","imageAndVideoContainer":"Rq-z","viewAllReviews":"Sq-z"};